/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authFullApp.defs.js'
export { main as default } from './authFullApp.defs.js'
